import React, { useEffect, useMemo, useRef, useState } from "react";
import { useControl, useControlReducer } from "../../../controlContext";
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/text.css'
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { resetElementHeight } from "../utils/helpers";
import { hashFromString } from "../../../../../shared/utils";
import { useDynamicTextAreaHeight } from "../utils/hooks";
import { OpenChatButton } from '../../../../revised_components/OpenChatButton';
import { Input, FormLabel, Textarea } from '@mui/joy';

export function TextControl({ label, name, idx, placeholder, displaySettings = {} }) {
  const [stateBuffer, setStateBuffer] = useState(false)
  const { [idx]: { [name]: controlVal, _id } } = useControl()
  // const [edit, setEdit] = useState(!value)
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(()=>( allReadOnly || ( lockMap && lockMap[_id] )), [allReadOnly, lockMap, _id])
  const controlReducer = useControlReducer()
  const value = useMemo(()=> stateBuffer || controlVal, [stateBuffer, controlVal])
  // const textRef = useRef()
  // const textContainerRef = useRef()

  // const contentHash = useMemo(()=>hashFromString(value || 'empty'), [value])
  const [textContainerRef, textRef] = useDynamicTextAreaHeight(readOnly, value)

  useEffect(() => {
    if (stateBuffer === false) return
    // if(!stateBuffer) return
    let timeout_id = setTimeout(() => {
      console.log('running changed effect in text', stateBuffer)
      setStateBuffer(false)
      controlReducer({ type: 'changed', name, idx, update:{[name]: stateBuffer }})
    }, 500)
    return () => { timeout_id && clearTimeout(timeout_id) }
  }, [stateBuffer, controlReducer, idx, name])

  // const shouldUpdateHeight = useMemo(()=>{
  //   // console.log('getting shouldUpdateHeight', name, !( (!stateBuffer && !value) || !displaySettings.as), value, displaySettings)
  //   if((!stateBuffer && !value) || !displaySettings.as) return false
  //   return stateBuffer || value
  // }, [value, stateBuffer, displaySettings])

  // useEffect(() => {
  //   if (readOnly) return resetElementHeight(textContainerRef.current)
  //   if (!shouldUpdateHeight) return
  //   textRef.current.style.height = 'auto'
  //   textContainerRef.current.style.minHeight = `${textRef.current.scrollHeight + 5}px`
  //   textRef.current.style.height = `${textRef.current.scrollHeight + 5}px`
  //   // console.log('text ref', textRef.current.scrollHeight)

  // }, [shouldUpdateHeight, readOnly])
  
  // const textControl = useMemo(() => {
    let labelElm =  useMemo(()=> !label ? [] : (
  
        <div style={{ marginBottom: '5px' }}>
          <FormLabel sx={{ m: 0 }}>{label}</FormLabel>
        </div>
    
    ), [label]) 

    const isTextarea = displaySettings?.as === 'textarea'
    const { as: _omitAs, visualVariant, size, ...restDisplay } = displaySettings || {}
    const controlProps = useMemo(() => {
      let props = restDisplay
      if (visualVariant) props = { ...props, variant: visualVariant }
      if (size) props = { ...props, size }
      return props
    }, [restDisplay, visualVariant, size])

    // console.log('recreating text control', name, idx, readOnly)
    return (
      <div className="text-control-container" >
        {labelElm}
       
          <div key={readOnly} ref={textContainerRef} >
            {
              !readOnly ? (
                <div>
                  {
                    isTextarea ? (
                      <textarea className="joy-like-markdown"
                        {...controlProps}
                        ref={textRef}
                        placeholder={placeholder || null}
                        defaultValue={value}
                        onChange={evt => setStateBuffer(evt.target.value)}
                     
                      />
                    ) : (
                      <Input
                        {...controlProps}
                        ref={textRef}
                        type="text"
                        placeholder={placeholder || null}
                        defaultValue={value}
                        onChange={evt => setStateBuffer(evt.target.value)}
                        color="neutral"
                      />
                    )
                  }
                  {
                    // Replace with ChatWrapper
                    /*
                    {displaySettings?.enableChat ? (
                      <OpenChatButton textSourceRef={textRef} fieldName={name}/>
                    ) : null}
                    */
                  }
                </div>
              ) : (
                <div {...restDisplay}>
                  {value && value.split('\n').map((spl, splIdx) => <div key={splIdx}>{spl}</div>)}
                </div>
              )
            }
          </div>
     
      </div>
    )
  // }, [readOnly, value, label, displaySettings, placeholder])


  // return textControl
}